module.exports = __webpack_public_path__ + "static/media/07_avatar_female.37605ca2.png";